import React, { useState, useEffect } from "react";
import { Autocomplete, TextField } from "@mui/material";
import { Category } from "../../types/Lessons";
import Api from "../../network/Api";

type CategoryAutocompleteProps = {
  value?: Category;
  onChange: (categories: Category | null) => void;
  onClose?: () => void;
  placeholder?: string;
};

const CategoryAutocomplete = (props: CategoryAutocompleteProps) => {

  const [options, setOptions] = useState<Category[]>([]);

  useEffect(() => {
    Api.get("/categories").then(response => {
      setOptions(response.items);
    });
  }, []);

  return <Autocomplete
    options={options}
    value={props.value}
    fullWidth
    disableClearable
    getOptionLabel={(category) => category.name}
    isOptionEqualToValue={(option, value) => option.id === value.id}
    onChange={(e, categories) => props.onChange(categories)}
    onClose={props.onClose}
    onBlur={props.onClose}
    onAbort={props.onClose}
    sx={{['.MuiAutocomplete-inputRoot'] : { padding: "0.5rem !important" }}}
    renderInput={(params) => (
      <TextField
        {...params}
        variant="filled"
        size="small"
        placeholder={props.placeholder}
      />
    )}
  />
};

export default CategoryAutocomplete;